import request from '@/utils/request'


// 查询分销列表
export function listDistribution(query) {
  return request({
    url: '/distribution/distribution/list',
    method: 'get',
    params: query
  })
}

// 查询分销分页
export function pageDistribution(query) {
  return request({
    url: '/distribution/distribution/page',
    method: 'get',
    params: query
  })
}

// 查询分销详细
export function getDistribution(data) {
  return request({
    url: '/distribution/distribution/detail',
    method: 'get',
    params: data
  })
}

// 新增分销
export function addDistribution(data) {
  return request({
    url: '/distribution/distribution/add',
    method: 'post',
    data: data
  })
}

// 修改分销
export function updateDistribution(data) {
  return request({
    url: '/distribution/distribution/edit',
    method: 'post',
    data: data
  })
}

// 删除分销
export function delDistribution(data) {
  return request({
    url: '/distribution/distribution/delete',
    method: 'post',
    data: data
  })
}
